import { Col, Row } from "antd";
import { OfficeCard } from "../../components/Office/OfficeCard";
import { OfficesGrid } from "../../../lib/constants";
import { groupBy, toPairs } from "ramda";
import { orderByDistance } from "lib/officeByDistance";
import { useLocation } from "react-router";
import CallIcon from "views/resources/icons/callIcon.svg";
import LocationIcon from "views/resources/icons/locationIcon.svg";
import React, { useCallback, useMemo, useState } from "react";
import ReserveIcon from "views/resources/icons/reserveIcon.svg";
import TicketIcon from "views/resources/icons/ticketIcon.svg";

import queryString from "query-string";
import styled from "styled-components";

export const OfficeList = ({ offices = [], center = false, mobile, limit }) => {
	const location = useLocation();

	const queryParams = queryString.parse(location.search);
	const { folder: queryFolder } = queryParams;

	// prevents the loop in case you've already clicked in the folder
	const isInFirstSearchResults = !!location.search && !queryFolder;
	const folderEntries = useMemo(
		() =>
			toPairs(
				groupBy((office) => (office.folder ? office.folder : ""))(
					offices
				)
			),
		[offices]
	);
	const officesByDistance = offices.length && orderByDistance(offices);
	const [state, setState] = useState({
		isHaveSubcategories: false,
	});
	const { isHaveSubcategories } = state;

	React.useEffect(() => {
		const isHaveSubcategories = folderEntries.reduce((acc, item) => {
			const [folder] = item;
			if (folder.length) {
				acc = true;
				return acc;
			}
			return acc;
		}, false);

		setState({ isHaveSubcategories });
	}, [folderEntries]);

	return (
		<StyledRow
			{...(center && { justify: "center" })}
			{...(!mobile && { gutter: 28 })}
		>
			{isInFirstSearchResults ? (
				<>
					{isHaveSubcategories && <Title>Subcategorías</Title>}
					{folderEntries.map(
						([folder, childOffices], i) =>
							folder && (
								<Col {...OfficesGrid} key={i} name={folder}>
									<OfficeCard
										office={childOffices[0]}
										folder={folder}
										childOffices={childOffices}
										mobile={mobile}
									></OfficeCard>
								</Col>
							)
					)}
					<Spacer />
					<Title>Sucursales</Title>
					<ContainerIcons>
						<Icon
							src={TicketIcon}
							style={{ minWidth: 24, maxWidth: 24 }}
						/>
						<TitleIcon>Tickets disponibles</TitleIcon>
						<Icon
							src={ReserveIcon}
							style={{ minWidth: 24, maxWidth: 24 }}
						/>
						<TitleIcon>Reservas disponibles</TitleIcon>
						<Icon small src={CallIcon} />
						<TitleIcon>Tipo de atención</TitleIcon>
						<Icon small src={LocationIcon} />
						<TitleIcon>Ubicación</TitleIcon>
					</ContainerIcons>

					{folderEntries.map(([_, childOffices]) =>
						childOffices
							// this prevents rendering already foldered offices in the
							// first search (avoids duplicates)
							.filter(({ folder }) => !folder)
							.map((office) => (
								<Col
									key={office.id}
									{...OfficesGrid}
									name={office.slug}
								>
									{!!office && (
										<OfficeCard
											office={office}
											mobile={mobile}
										/>
									)}
								</Col>
							))
							.slice(0, limit ? limit : childOffices.length)
					)}
				</>
			) : officesByDistance && officesByDistance.length ? (
				officesByDistance.map((office, i) => (
					<Col key={i} {...OfficesGrid}>
						{!!office && (
							<OfficeCard office={office} mobile={mobile} />
						)}
					</Col>
				))
			) : (
				""
			)}
		</StyledRow> // for other lists, eg. favorites
	);
};

// patch for last element to render "above" the navbar
const StyledRow = styled(Row)`
	.ant-col-xs-24:last-child {
		margin-bottom: 60px;
	}
`;

const Title = styled.div`
	font-weight: 600;
	color: #8c8c8c;
	margin-bottom: 8px;
	font-size: 14px;
	width: 100%;
	@media (min-width: 1024px) {
		font-size: 20px;
	}
`;

const Spacer = styled.div`
	margin-bottom: 16px;
	width: 100%;
`;

const Icon = styled.img`
	@media (min-width: 1024px) {
		width: ${({ small }) => (small ? "20px;" : "25px;")};
	}
	${({ small }) => (small ? "width: 16px;" : "")};
`;

const ContainerIcons = styled.div`
	width: 100%;
	padding-left: 6px;
	margin-bottom: 12px;
	white-space: nowrap;
	display: inline-block;
	position: relative;
	overflow: auto;
	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: none;
	}
	@media (min-width: 1024px) {
		margin: 24px 0px;
		padding-left: 6px;
	}
`;

const TitleIcon = styled.span`
	font-size: 13px;
	color: #8c8c8c;
	margin-left: 8px;
	margin-right: 24px;
	@media (min-width: 1024px) {
		font-size: 0.9rem;
		margin-right: 32px;
	}
`;
